import { render, staticRenderFns } from "./AdministrativeFiles.vue?vue&type=template&id=fd7922b2&"
import script from "./AdministrativeFiles.vue?vue&type=script&lang=js&"
export * from "./AdministrativeFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports